import { restAPI } from '../rest-api';

import { FinalReportTemplate } from '~/interfaces/FinalReportTemplate';

const endpoints = restAPI.injectEndpoints({
  endpoints: (builder) => ({
    templates: builder.query<FinalReportTemplate[], { slug: string }>({
      query: ({ slug }) => ({
        url: `/tenant/${slug}/final-report-templates-list`,
      }),
      providesTags: (res) =>
        res ? [{ type: 'Reports', id: 'final-report-templates' }] : [],
    }),
    createTemplate: builder.mutation<
      string,
      {
        slug: string;
        template: FinalReportTemplate;
      }
    >({
      query: ({ slug, template }) => ({
        url: `/tenant/${slug}/final-report-templates`,
        method: 'POST',
        data: template,
      }),
      invalidatesTags: (res) =>
        res ? [{ type: 'Reports', id: 'final-report-templates' }] : [],
    }),
    editTemplate: builder.mutation<
      string,
      {
        slug: string;
        id: number;
        template: FinalReportTemplate;
      }
    >({
      query: ({ slug, id, template }) => ({
        url: `/tenant/${slug}/final-report-templates/${id}`,
        method: 'PATCH',
        data: template,
      }),
      invalidatesTags: (res) =>
        res ? [{ type: 'Reports', id: 'final-report-templates' }] : [],
    }),
    deleteTemplate: builder.mutation<
      string,
      {
        slug: string;
        id: number;
      }
    >({
      query: ({ slug, id }) => ({
        url: `/tenant/${slug}/final-report-templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Reports', id: 'final-report-templates' }],
    }),
  }),
  overrideExisting: false,
});

export const FinalReportService = endpoints;
